/**
 * Liste des ingrédients courants (cliquer pour ajouter)
 */

import React from "react";
import { commonIngredients } from "../constants/ingredients.js";
import { translateToEnglish } from "../utils/translateToEnglish.js";

export default function CommonIngredientsSection({
  availableIngredients,
  addIngredient,
  getIngredientLabel,
  t,
}) {
  const available = commonIngredients.filter(
    (ing) => !availableIngredients.includes(ing),
  );
  return (
    <div className="mb-4">
      <p className="text-xs font-medium text-white/80 mb-2">
        {t("clickToAddQuickly")} ({available.length} {t("availableSuggestions")}
        )
      </p>
      <div className="flex flex-wrap gap-2">
        {available.slice(0, 24).map((ingredient) => {
          const translated = translateToEnglish(ingredient);
          const hasTranslation = translated !== ingredient.toLowerCase();
          return (
            <button
              key={ingredient}
              type="button"
              onClick={() => addIngredient(ingredient)}
              className="px-3 py-1.5 bg-white/10 hover:bg-white/20 text-white/95 rounded-lg text-sm border border-white/20 transition-colors"
              title={hasTranslation ? `Recherche: ${translated}` : undefined}
            >
              + {getIngredientLabel(ingredient)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
